<template>
  <div>
    <!-- banner区域 -->
    <div class="relative w-full h-[300px] sm:h-[400px] md:h-[600px] lg:h-[800px]">
      <video
        ref="videoRef"
        src="../../assets/img/xr_jy.mp4"
        autoplay
        loop
        muted
        class="w-full h-full object-cover z-0"
        @loadedmetadata="skipFirstSecond"
      />
      <div class="absolute bottom-4 sm:bottom-8 md:bottom-[49px] left-0 right-0 w-full h-full z-10 flex flex-col items-center justify-end px-4 sm:px-6">
        <div class="text-white text-[32px] sm:text-[48px] md:text-[64px] lg:text-[96px] font-black text-center leading-none m-0">
          XR剧院
        </div>
        <div class="text-white text-[24px] sm:text-[36px] md:text-[48px] lg:text-[72px] font-black text-center leading-none m-0">
          XR THEATER
        </div>
        <div class="text-white text-[14px] sm:text-[20px] md:text-[28px] lg:text-[36px] font-[w400] text-center leading-none m-0 z-20">
          LBE大空间
        </div>
        <div class="h-[8px] sm:h-[12px] md:h-[15px] lg:h-[17px] w-full max-w-[300px] sm:max-w-[500px] md:max-w-[800px] lg:max-w-[1199px] bg-[#0BE0BB] rounded-2xl -mt-[6px] sm:-mt-[8px] md:-mt-[10px] lg:-mt-[12px]">
        </div>
      </div>
    </div>
    <!-- 产品支持 -->

    <div class="flex flex-col items-center justify-center container mx-auto pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-6 sm:pb-8 md:pb-10 lg:pb-[52px] px-4 sm:px-6">
      <img
        src="../../assets/img/prosupport.webp"
        alt="productSupport"
        class="mb-6 sm:mb-8 md:mb-10 lg:mb-[46px] scroll-fade-in max-w-[80px] sm:max-w-[100px] md:max-w-[120px] lg:max-w-[265px]"
      >
      <div
        class="text-[#333333] text-[14px] sm:text-[16px] md:text-[20px] lg:text-[24px] font-normal 
        text-center mb-8 sm:mb-12 md:mb-16 lg:mb-[77px] scroll-fade-in leading-relaxed px-4"
        style="font-family: 'Noto Sans SC'; font-weight: normal;"
      >我们旗下拥有多款XR大空间核心产品<br />
        《恐龙星球》《行星之旅》《墨宇寻踪》《赛博朋克：数据织梦者》《深海启航：亚特兰蒂斯之光》...等等片源<br />
        均提供全流程部署支持与技术保障。<br />
        从前期硬件适配测试、软件环境搭建，到中期多终端部署调试、数据迁移对接，再到后期系统运维升级，专业技术团队全程<br />跟进。</div>
      <!-- 产品图片轮播 -->
      <div class="product-carousel-container w-full overflow-hidden scroll-fade-in">
        <div class="relative">
          <!-- 轮播容器 -->
          <div
            class="flex transition-transform duration-1000 ease-in-out"
            :style="{ transform: `translateX(-${currentIndex * (100 / visibleCount)}%)` }"
          >
            <!-- 产品图片列表 -->
            <div
              v-for="(product, index) in displayProducts"
              :key="`${product.id}-${index}`"
              class="shrink-0 pr-3 sm:pr-4 md:pr-6"
              :style="{ width: `${100 / visibleCount}%` }"
            >
              <div class="relative h-auto overflow-hidden shadow-lg hover:scale-105 transition-transform duration-300">
                <img
                  :src="product.image"
                  :alt="product.title"
                  class="w-full h-full object-cover"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 定制开发 -->
    <div class="custom-development bg-[#030D1E] w-full pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-12 sm:pb-16 md:pb-20 lg:pb-[130px]">
      <div class="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8">
        <div class="flex flex-col items-center">
          <!-- 标题 -->
          <img
            src="../../assets/img/cudev.webp"
            alt="custom-development"
            class="mb-6 sm:mb-8 md:mb-10 lg:mb-[46px] max-w-[80px] sm:max-w-[100px] md:max-w-[120px] lg:max-w-[265px] scroll-fade-in"
          >

          <!-- 描述文字 -->
          <div class="text-white scroll-fade-in text-[14px] sm:text-[16px] md:text-[18px] lg:text-xl text-center max-w-[1200px] mb-8 sm:mb-12 md:mb-16 leading-relaxed scroll-fade-in px-4">
            <p>
              针对LBE-VR大空间定制开发，我们可深度贴合剧目主题与场地特性，打造专属虚拟演艺空间。<br />
              从定制化剧情分支交互系统、角色动作捕捉方案，到沉浸式场景建模、空间音效设计，均能精准匹配艺术表达需求。<br />
              技质感与叙事张力，为观众带来独一无二的 XR 观演体验。
            </p>
          </div>

          <!-- 技术图标区域 -->
          <div class="w-full max-w-[1200px]">
            <!-- 上方两个图标：左右分布 -->
            <div class="container m-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-0">
              <!-- 技术1：高精准定位技术（左上） -->
              <div class="flex flex-col sm:flex-row items-center justify-center min-h-[150px] sm:min-h-[200px] h-auto sm:h-[350px] mt-4 sm:mt-6 lg:mt-0">
                <div class="md:w-full sm:w-1/2 flex justify-center h-[150px] sm:h-[350px] scroll-fade-in-left">
                  <img
                    src="../../assets/img/c1.webp"
                    alt="高精准定位技术"
                    class="w-full h-full object-cover"
                  >
                </div>
                <div
                  class="flex flex-col h-full md:w-full sm:w-1/2 p-4 sm:p-[24px] justify-center scroll-fade-in-right"
                  style="background: rgba(3, 3, 3, 0.4);"
                >
                  <div class="text-white text-[16px] sm:text-[20px] md:text-[24px] font-bold mb-2">
                    高精准定位技术
                  </div>
                  <p class="text-white text-[12px] sm:text-[14px] md:text-[18px]">
                    High-Precision<br />Positioning Technology
                  </p>
                </div>
              </div>

              <!-- 技术2：低延迟、高帧率渲染技术（右上） -->
              <div class="flex flex-col sm:flex-row items-center justify-center min-h-[150px] sm:min-h-[200px] h-auto sm:h-[350px] mt-4 sm:mt-6 lg:mt-0">
                <div class="md:w-full sm:w-1/2 flex justify-center h-[150px] sm:h-[350px] scroll-fade-in-right">
                  <img
                    src="../../assets/img/c2.webp"
                    alt="低延迟、高帧率渲染技术"
                    class="w-full h-full object-cover"
                  >
                </div>
                <div
                  class="flex flex-col h-full md:w-full sm:w-1/2 p-4 sm:p-[24px] justify-center scroll-fade-in-left"
                  style="background: rgba(3, 3, 3, 0.4);"
                >
                  <div class="text-white text-[16px] sm:text-[20px] md:text-[24px] font-bold mb-2">
                    低延迟、高帧率渲染技术
                  </div>
                  <p class="text-white text-[12px] sm:text-[14px] md:text-[18px]">
                    Low-Latency, <br />High-Frame-Rate <br />Rendering Technology
                  </p>
                </div>
              </div>
            </div>

          </div>
          <!-- 技术3：多人实时互动协作技术（底部居中） -->
          <div class="flex flex-col sm:flex-row items-center justify-center min-h-[150px] sm:min-h-[200px] h-auto sm:h-[350px] mt-4 sm:mt-6 lg:mt-0 w-full lg:w-1/2 lg:mx-auto">
            <div class="w-full sm:w-1/2 flex justify-center h-[150px] sm:h-[350px] scroll-fade-in-left">
              <img
                src="../../assets/img/c3.webp"
                alt="多人实时互动协作技术"
                class="w-full h-full object-cover"
              >
            </div>
            <div
              class="flex flex-col h-full w-full sm:w-1/2 p-4 sm:p-[24px] justify-center scroll-fade-in-right"
              style="background: rgba(3, 3, 3, 0.4);"
            >
              <div class="text-white text-[16px] sm:text-[20px] md:text-[24px] font-bold mb-2">
                多人实时互动协作技术
              </div>
              <p class="text-white text-[12px] sm:text-[14px] md:text-[18px]">
                Real-Time Interactive<br />Collaboration Technology For <br />Multiple People
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- 播控系统-->
    <!--  线下体验 -->
    <div
      class="pb-12 sm:pb-16 md:pb-20 lg:pb-[169px] pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] px-4 sm:px-6"
      :style="{ backgroundImage: `url(${boardBgImg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }"
    >
      <div class="flex flex-col items-center justify-center w-full mx-auto">
        <img
          :src="boardImg"
          alt="offline"
          class="mb-6 sm:mb-8 md:mb-10 lg:mb-[34px] scroll-fade-in max-w-[80px] sm:max-w-[100px] md:max-w-[120px] lg:max-w-[265px]"
        >
        <div class="text-[#333333] text-[14px] sm:text-[16px] scroll-fade-in md:text-[20px] lg:text-[24px] mb-4 sm:mb-6 md:mb-8 text-center leading-relaxed px-4">
          我们针对市面多样的片源与眼镜设备，进行整合规划并开发出一整套播控系统。<br />
          该系统可实现不同眼镜的互联互通，同时对片源进行全面监管；集成票务系统、硬件管理及片源管理功能，形成一体化<br />操作体系，大幅提升运营效率与管控能力。
        </div>
        <div class="flex flex-col lg:flex-row items-center justify-center container mx-auto gap-6 sm:gap-8 lg:gap-0 scroll-fade-in-left">
          <div class="flex flex-col justify-center items-center lg:items-start mr-10">
            <div class="text-[#07409D] font-bold text-[28px] sm:text-[40px] md:text-[72px] lg:text-[72px] text-center lg:text-left">
              多样硬件集成<br />
              全面监管 </div>
            <div class="text-[#07409D] text-[16px] sm:text-[20px] md:text-[36px] lg:text-4xl text-center lg:text-left mt-2 sm:mt-4 font-bold md:mb-[43px]">
              Integration of diverse hardware<br />
              Comprehensive supervision</div>
            <div
              class="text-[#07409D] text-center text-[36px] font-bold sm:text-base rounded-[12px] px-6 sm:px-8 md:px-[48px] lg:px-[48px] py-4 sm:py-6 md:py-[30px] lg:py-[30px] border-[#ffffff] border mt-6 sm:mt-8 md:mt-[43px] cursor-pointer hover:opacity-90 transition-opacity"
              style="background: rgba(11, 224, 187, 0.2);"
              @click="goToProductPage"
            >了解详情>></div>
          </div>
          <img
            src="../../assets/img/computer.webp"
            alt="offline"
            class="w-full max-w-[300px] sm:max-w-[400px] md:max-w-[500px] lg:w-[636px] lg:max-w-[636px] h-auto lg:h-[537px] object-contain scroll-fade-in-right"
          >
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <ContactUs />
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, computed } from "vue";
import { useRouter } from "vue-router";
import park_1 from "@/assets/img/park_1.jpg";
import park_2 from "@/assets/img/park_2.jpg";
import park_3 from "@/assets/img/park_3.jpg";
import park_4 from "@/assets/img/park_4.jpg";
import park_5 from "@/assets/img/park_5.jpg";
import boardImg from "@/assets/img/board.webp";

import boardBgImg from "@/assets/img/board-bg.webp";
import ContactUs from "@/components/ContactUs.vue";

const router = useRouter();

// 视频引用
const videoRef = ref<HTMLVideoElement | null>(null);

// 跳过第一秒
const skipFirstSecond = () => {
  if (videoRef.value) {
    videoRef.value.currentTime = 1.5;
  }
};

// 跳转到产品页面
const goToProductPage = () => {
  router.push("/product.html");
};

// 产品图片数据
const products = [
  {
    id: 1,
    title: "墨宇寻踪",
    subtitle: "INK SPACE TRACING",
    image: park_1,
  },
  {
    id: 2,
    title: "恐龙星球",
    subtitle: "COSMIC QUEST PLANET DINOSAUR",
    image: park_2,
  },
  {
    id: 3,
    title: "行星之旅",
    subtitle: "COSMIC QUEST PLANETARY JOURNEY",
    image: park_3,
  },
  {
    id: 4,
    title: "赛博朋克：数据织梦者",
    subtitle: "CYBERPUNK: DATA DREAM WEAVER",
    image: park_4,
  },
  {
    id: 5,
    title: "深海启航：亚特兰蒂斯之光",
    subtitle: "DEEP SEA VOYAGE: LIGHT OF ATLANTIS",
    image: park_5,
  },
  // 添加更多产品以实现无缝循环
  {
    id: 6,
    title: "墨宇寻踪",
    subtitle: "INK SPACE TRACING",
    image: park_1,
  },
  {
    id: 7,
    title: "恐龙星球",
    subtitle: "COSMIC QUEST PLANET DINOSAUR",
    image: park_2,
  },
  {
    id: 8,
    title: "行星之旅",
    subtitle: "COSMIC QUEST PLANETARY JOURNEY",
    image: park_3,
  },
  {
    id: 9,
    title: "赛博朋克：数据织梦者",
    subtitle: "CYBERPUNK: DATA DREAM WEAVER",
    image: park_4,
  },
  {
    id: 10,
    title: "深海启航：亚特兰蒂斯之光",
    subtitle: "DEEP SEA VOYAGE: LIGHT OF ATLANTIS",
    image: park_5,
  },
];

// 响应式计算可见数量
const visibleCount = computed<number>(() => {
  if (typeof window !== "undefined") {
    if (window.innerWidth < 640) return 1; // 移动端显示1张
    if (window.innerWidth < 1024) return 2; // 平板显示2张
    if (window.innerWidth < 1280) return 3; // 小桌面显示3张
    return 5; // 大桌面显示5张
  }
  return 5;
});

const currentIndex = ref(0);
let autoSlideInterval: ReturnType<typeof setInterval> | null = null;
const windowWidth = ref(0);

// 计算显示的产品列表
const displayProducts = computed(() => {
  return products;
});

// 更新窗口宽度
const updateWindowWidth = () => {
  if (typeof window !== "undefined") {
    windowWidth.value = window.innerWidth;
  }
};

// 自动滑动函数
const autoSlide = () => {
  const count = visibleCount.value;
  if (products.length <= count) return;

  currentIndex.value++;
  // 当滑动到末尾时，无缝循环到开头
  if (currentIndex.value > products.length - count) {
    // 等待动画完成后重置到开头
    setTimeout(() => {
      currentIndex.value = 0;
    }, 1000); // 等待动画完成后再重置
  }
};

// 启动自动轮播
const startAutoSlide = () => {
  if (autoSlideInterval) {
    stopAutoSlide();
  }
  autoSlideInterval = setInterval(() => {
    autoSlide();
  }, 3000); // 每3秒滑动一次
};

// 停止自动轮播
const stopAutoSlide = () => {
  if (autoSlideInterval) {
    clearInterval(autoSlideInterval);
    autoSlideInterval = null;
  }
};

// 存储已触发动画的元素
const animatedElements = new Set<HTMLElement>();

// Intersection Observer 配置
const observerOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1, // 当元素10%可见时触发
};

// 创建 Intersection Observer
let observer: IntersectionObserver | null = null;

onMounted(() => {
  // 初始化窗口宽度
  updateWindowWidth();
  window.addEventListener("resize", updateWindowWidth);

  // 确保在组件挂载后再启动
  if (products.length > 0) {
    startAutoSlide();
  }

  // 创建 observer 来观察滚动动画元素
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        !animatedElements.has(entry.target as HTMLElement)
      ) {
        // 元素进入视口且未触发过动画
        const element = entry.target as HTMLElement;
        element.classList.add("fade-in-visible");
        animatedElements.add(element);
      }
    });
  }, observerOptions);

  // 观察所有带有滚动动画类的元素
  const elements = document.querySelectorAll(
    ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
  );
  elements.forEach((element) => {
    if (observer) {
      observer.observe(element);
    }
  });
});

onBeforeUnmount(() => {
  stopAutoSlide();
  window.removeEventListener("resize", updateWindowWidth);
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped>
.title-family-bold {
  font-family: "Noto Sans SC";
  font-size: 24px;
  font-weight: bold;
}

.title-family-normal {
  font-family: "Noto Sans SC";
  font-size: 24px;
  font-weight: normal;
}

.title-family-light {
  font-family: "Noto Sans SC";
  font-size: 24px;
  font-weight: light;
}

/* 滚动动画效果 - 小元素从底部飞入 */
.scroll-fade-in {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

/* 滚动动画效果 - 从左边飞入 */
.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

/* 滚动动画效果 - 从右边飞入 */
.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

.product-carousel-container {
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.05));
  position: relative;
}

/* 右侧遮罩层 */
.product-carousel-container::before {
  content: "";
  background: linear-gradient(270deg, #fff 1%, hsla(0, 0%, 82%, 0));
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  z-index: 2;
  pointer-events: none;
}

/* 左侧遮罩层 */
.product-carousel-container::after {
  content: "";
  background: linear-gradient(90deg, #fff 1%, hsla(0, 0%, 82%, 0));
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  z-index: 2;
  pointer-events: none;
}

@media (min-width: 640px) {
  .product-carousel-container::before,
  .product-carousel-container::after {
    width: 150px;
  }
}

@media (min-width: 1024px) {
  .product-carousel-container::before,
  .product-carousel-container::after {
    width: 200px;
  }
}
</style>
